import React from 'react'
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom'
import green_switch_cma from '../assets/images/green_switch_cma.png'
import instructor from '../assets/images/instructor.png';
import purpledot from '../assets/images/purple_squre_dots.b6e7dbcc.svg';
import yellowdot from '../assets/images/yellow_squre_dots.a8deef14.svg';
import Img2 from '../assets/images/real-time.png'
import Img1 from '../assets/images/img.png'
import vdo1 from '../assets/video/vdo1.mp4'
import v1 from '../assets/images/v1.png'
import v2 from '../assets/images/v2.png'
import v3 from '../assets/images/v3.png'
import v4 from '../assets/images/v4.png'

function CmaStudyMaterial() {
    return (
        <>
            <Helmet>
                <title>US CMA Studay Material in India by KC Globed: Affordable CMA Certification</title>

                <meta name="description" content="Discover the US CMA Studay Material in India with KC Globed. Get detailed information on costs, affordable pricing and expert training to achieve CMA certification." />

                <link rel="canonical" href="" />

                <meta name="robots" content="index, follow" />
            </Helmet>

            <div className="overflow-hidden bg-placement-hero bg-cover w-full">
                <div className="max-w-7xl m-auto relative isolate px-6 pt-14 lg:px-8 h-[55%] md:h-[50%] lg:h-[80%] lg:mb-0 lg:pt-2 xl:pt-2">
                    <img src={green_switch_cma} alt="CMA Fees" className="absolute object-contain inset-0 z-10 scale-75 lg:scale-[70%] -mt-14 ml-16 md:ml-32 md:-mt-32 lg:ml-52 lg:-mt-40 xl:-mt-[16rem] mt-[0] xl:scale-[65%] xl:ml-96 2xl:ml-[22rem]" />
                    <div className="mx-auto py-10 md:py-24 lg:py-48 relative z-10 text-white">
                        <div className="mx-auto lg:max-w-5xl">
                            <h1 className="text-left lg:text-5xl md:text-4xl text-3xl font-bold text-gray-700 lg:w-[38%] w-[50%] mb-2 lg:leading-[56px]"><span className="block">CMA Study Material</span></h1>

                            <div className="scale-[60%] md:scale-75 lg:scale-100 mt-5 md:mt-4 lg:mt-10 flex flex-row gap-10 -ml-24 md:-ml-28 lg:ml-0 items-start justify-start gap-x-2 lg:gap-x-6">
                                <div className="box box_btn transform transition-transform duration-300 hover:scale-110" tabindex="0">
                                    <Link to="https://www.kcglobed.com/contactus#EnquireForm"
                                        className="relative lg:top-[33px] bg-[#fbb03b] transition duration-300 rounded-3xl bg-primary px-6 py-4 text-sm font-semibold text-gray-700 shadow-sm hover:bg-primary hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary pb-4 cursor-pointer"
                                    >
                                        Enquiry Now
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="relative bg-[#f2f2f2] p-4 md:p-8 lg:p-0 py-[31px] pb-24">
                <img src={purpledot} alt="purpledot" className='absolute w-[91px] left-[21px] top-[2rem]' />
                <div className="flex flex-col items-center">
                    <div tabindex="0">
                        <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 items-center xs:max-w-xl lg:max-w-6xl group h-full">
                            <div className="flex flex-col ml-0 lg:ml-6">
                                <div className="relative overflow-hidden">
                                    <div className="max-w-[100rem] mx-auto py-5">
                                        <div className="max-w-3xl mx-auto">
                                            <h2 className="text-3xl font-semibold text-gray-800 sm:text-4xl md:text-4xl "><span className="uppercase text-xl">CMA Exam Study Guide</span></h2>

                                            <p className="mt-4 text-sm md:text-base text-left text-gray-700">Preparing for the Certified Management Accountant (CMA) exam demands the right strategy and tools. Our comprehensive <strong>CMA study material</strong> is designed to help candidates master the concepts required for both Part 1 and Part 2 of the exam. From financial reporting and performance management to strategic financial decision-making, we've got you covered. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <img src={instructor} alt="CMA Exam Study Guide" className="mt-6 lg:pl-10" />
                        </div>
                    </div>
                </div>
                <img src={yellowdot} alt="yellowdot" className='w-[51px] absolute bottom-[2rem] right-[21px]' />
            </div>

            <div class="relative lg:py-10 lg:px-20 py-0">
                <div className="lg:max-w-5xl mx-auto flex flex-col gap-2 md:gap-2 lg:gap-2 xl:gap-6 2xl:gap-8 lg:pt-4 text-xl p-3 -mt-2 bg-[#7F56D9] rounded-xl text-[#fff]">
                    <div className="relative overflow-hidden">
                        <div className="flex flex-col gap-1">
                            <div className='mx-auto gap-0 items-center xs:max-w-xl lg:max-w-4xl group h-full'>
                                <p className="text-white mb-3 text-center font-bold text-2xl">KC Globed’s CMA Review Course: Your Path to Success</p>
                                <p className='text-white mb-3 text-center'>At KC Globed, we provide expert-curated US <strong>CMA study material</strong> that aligns with IMA's exam blueprint. Our CMA review course includes high-yield notes, practice questions, mock exams, and exam simulation software to boost your confidence and exam readiness.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="p-4 md:p-8 lg:p-10">
                <div className="flex flex-col items-center">
                    <div tabindex="0" className='transform transition-transform duration-300'>
                        <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 lg:mb-5 items-center xs:max-w-xl lg:max-w-6xl group h-full bg-white">
                            <div className="relative h-50 w-30 mb-6 lg:pr-10">
                                <video style={{ zIndex: '4' }} className='absolute w-[97%] sm:w-[51.5%] sm:top-[23px] top-[20px] left-[7px] lg:w-[327px] lg:top-[25px] lg:left-[39px]'
                                    controls
                                    autoPlay
                                    muted
                                    playsInline
                                    loop
                                >
                                    <source src={vdo1} type="video/mp4" />
                                </video>
                                <img style={{ zIndex: '3' }} className='relative w-[344px] ml-[0px] lg:w-[344px] lg:ml-[31px]' src={v1} alt="Personalized Learning for Efficient Study with T.E.E.E Technology" />

                                <img style={{ zIndex: '3' }} className='absolute bottom-[60px] left-[126px] w-[30px] sm:bottom-[77px] sm:left-[161px] lg:bottom-[77px] lg:left-[191px] lg:w-[30px]' src={v2} alt="v2" />

                                <img className='absolute w-[71px] bottom-[31px] left-[-10px] lg:w-[71px] lg:bottom-[43px] lg:left-[21px]' src={v3} alt="v3" />

                                <img className='absolute top-[-13px] right-[-27px] w-[93px] sm:right-[261px] lg:top-[-28px] lg:right-[123px] lg:w-[93px]' src={v4} alt="v4" />

                            </div>
                            <div className="flex flex-col lg:mr-6">
                                <p className="text-xl font-semibold md:text-2xl mb-4 placeholder gap-1"><span>Tailored </span><span className="text-gray-500"> Learning for Effective Study</span></p>

                                <p className="text-[15px] text-base md:text-medium text-left text-dark_text">
                                Every student learns differently. We’ve designed our <strong>CMA prep materials</strong>  to adapt to your learning style. Whether you're a visual learner or prefer text-based instruction, our platform offers videos, summaries, flashcards, and detailed explanations tailored to your pace.</p>
                            </div>
                        </div>
                    </div>
                    <div tabindex="0" className='transform transition-transform duration-300 hover:scale-110'>
                        <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 mb-10 items-center xs:max-w-xl lg:max-w-5xl group h-full bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
                            <div className="flex flex-col ml-0 lg:ml-6">
                                <p className="text-xl font-semibold md:text-2xl mb-4"><span>Instant Score</span><span className="text-gray-500 lg:block"> Tracking and Analysis</span></p>
                                <p className="text-[15px] text-base md:text-medium text-left text-dark_text">
                                With our smart analytics dashboard, you can track your progress and performance in real time. Using our intuitive performance tracker, which is built into all <strong>CMA course study material</strong> packages, you can identify weak areas, improve on difficult topics, and optimize your preparation strategy.</p>
                            </div>
                            <img src={Img2} alt="Real-Time Score Analysis" className="mt-6 lg:pl-10" />
                        </div>
                    </div>


                    <div tabindex="0" className='transform transition-transform duration-300 hover:scale-110'>
                        <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 mb-5 items-center xs:max-w-xl lg:max-w-5xl group h-full bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
                            <img src={Img1} alt="KC GlobEd’s CMA Review Course: Your Roadmap to Success" className="h-50 w-30 mb-6 lg:pr-10" />
                            <div className="flex flex-col lg:mr-6">
                                <p className="text-xl font-semibold md:text-2xl mb-4 placeholder gap-1"><span>KC GlobEd’s  </span><span className="text-gray-500">KC Globed’s CMA Review Course:  <br />Your Roadmap to Success </span></p>

                                <p className="text-[15px] text-base md:text-medium text-left text-dark_text">
                                Join thousands of successful candidates who trusted KC Globed’s <strong>CMA exam study material</strong> to ace the exam. Our industry-leading instructors, updated content, and easy-to-understand modules provide a seamless path toward CMA success.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="p-4 md:p-8 lg:p-10 bg-[#f5f9f3] pt-10 lg:pt-0">
                <div className="flex flex-col items-center">
                    <div tabindex="0" className='transform transition-transform duration-300 hover:scale-110 '>
                        <div className="mt-[3.5rem] grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 mb-5 items-center xs:max-w-xl lg:max-w-5xl group h-full bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
                            <div className="flex flex-col ml-0 lg:ml-6">
                                <p className="text-xl font-semibold md:text-2xl mb-4"><span>Adopt Effective </span><span className="text-gray-500 lg:block">Study Strategies</span></p>
                                <p className="text-[15px] text-base md:text-medium text-left text-dark_text">
                                Maximize your productivity with time-saving study hacks, guided video sessions, and a structured timetable. Smart preparation leads to smarter results—especially when using certified CMA prep materials built for efficiency and results.</p>
                            </div>
                            <img src={Img2} alt="Adopt Effective Study Strategies" className="mt-6 lg:pl-10" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-first-step py-5 bg-center bg-no-repeat bg-cover">
                <div className="flex flex-col items-center">
                    <div className="relative overflow-hidden">
                        <div className="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8 py-10">
                            <div className="max-w-3xl text-center mx-auto">
                                <h2 className='font-bold text-white text-3xl'>Get Access to the Top CMA Review Materials Today!</h2>
                                <p className="mt-4 text-md text-medium font-bold text-white">
                                Ready to conquer the CMA exam? Get started with KC Globed’s premium <strong>Certified Management Accountant study materials</strong> Certified Management Accountant study materials today. Don’t leave your success to chance—equip yourself with the best tools and expert support available!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default CmaStudyMaterial;
